export default class ChallengeDetailsResponse {
    constructor(supportedLocales = []) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: null,
                verificationInstruction: '<span></span>',
                pushMessage: '',
            };
        });

        this.coinsToEarn = null;
        this.activeFrom = null;
        this.activeTo = null;
        this.challengeType = null;
        this.activityType = null;
        this.measureUnit = null;
        this.goalValue = null;
        this.action = null;
        this.cyclical = null;
        this.relatedToCommuteWork = null;
        this.transport = null;
        this.sendPushWhenCompleted = true;
        this.supportedLocales = supportedLocales;
        this.publishedToCompanies = [];
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.status = from.status;
            to.coinsToEarn = from.coinsToEarn;
            to.goalValue = from.goalValue;
            to.activeFrom = new Date(from.activeFrom);
            to.activeTo = new Date(from.activeTo);
            to.photo = from.photo;
            to.challengeType = from.challengeType;
            to.activityType = from.activityType;
            to.cyclical = from.cyclical;
            to.relatedToCommuteWork = from.relatedToCommuteWork;
            to.measureUnit = from.measureUnit;
            to.action = from.action;
            to.transport = from.transport;
            to.sendPushWhenCompleted = from.sendPushWhenCompleted;
            to.publishedToCompanies = from.publishedToCompanies || [];
            const locales = (to && Array.isArray(to.supportedLocales) && to.supportedLocales.length > 0)
                ? to.supportedLocales
                : Object.keys(from?.translations || {});
            locales.forEach((element) => {
                to.translations[element] = {
                    title: from?.translations?.[element]?.title,
                    description: from?.translations?.[element]?.description,
                    pushMessage: from?.translations?.[element]?.pushMessage,
                };
            });
        } else {
            to = new ChallengeDetailsResponse();
        }
    }

    static copy(to, from) {
        ChallengeDetailsResponse.assign(from, to);
        return to;
    }
}
